import { render, staticRenderFns } from "./assign-to.vue?vue&type=template&id=5d2c0e15&scoped=true"
import script from "./assign-to.vue?vue&type=script&lang=js"
export * from "./assign-to.vue?vue&type=script&lang=js"
import style0 from "./assign-to.vue?vue&type=style&index=0&id=5d2c0e15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2c0e15",
  null
  
)

export default component.exports